<div class="button-toggle_item" [ngClass]="{ 'active': isActive, 'disable':isDisabled }" (click)="select()">
  <ng-content></ng-content>
</div>
